import {Component, inject, signal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {OidcSecurityService} from 'angular-auth-oidc-client';

import {environment} from '../../../../environments/environment';
import {logoutWithFallback} from '../../auth/logout';

@Component({
    selector: 'app-page-error',
    standalone: true,
    templateUrl: './page-error.component.html',
    styleUrl: './page-error.component.scss',
})
export class PageErrorComponent {
    private readonly oidcSecurityService = inject(OidcSecurityService);
    readonly portalUrl = `${environment.portalUrl}?referrer=${encodeURIComponent(environment.clientId)}`;
    readonly isLoggingOut = signal(false);

    errorCode: number | null = 403;
    errorTitle: string = 'Forbidden';
    errorMessage: string = 'คุณไม่มีสิทธิ์เข้าถึงหน้านี้ กรุณาติดต่อผู้ดูแลระบบเพื่อตรวจสอบสิทธิ์ของบัญชี';

    constructor(private route: ActivatedRoute) {
        const code = this.route.snapshot.paramMap.get('code');
        if (this.route.snapshot.routeConfig?.path === 'logout') {
            this.errorCode = null;
        } else if (code) {
            this.errorCode = parseInt(code, 10);
        } else if (this.route.snapshot.routeConfig?.path === 'error/401') {
            this.errorCode = 401;
        }
        this.setErrorMessage();
    }

    login(): void {
        this.oidcSecurityService.authorize();
    }

    logout(): void {
        if (this.isLoggingOut()) {
            return;
        }
        this.isLoggingOut.set(true);
        logoutWithFallback(this.oidcSecurityService, url => this.redirectTo(url));
    }

    private redirectTo(url: string): void {
        window.location.assign(url);
    }

    private setErrorMessage(): void {
        switch (this.errorCode) {
            case null:
                this.errorTitle = 'Signed Out';
                this.errorMessage = 'คุณออกจากระบบเรียบร้อยแล้ว';
                break;
            case 401:
                this.errorTitle = 'Unauthorized';
                this.errorMessage = 'เซสชันหมดอายุหรือไม่ได้รับอนุญาต กรุณาออกจากระบบหรือเข้าสู่ระบบใหม่อีกครั้ง';
                break;
            case 403:
                this.errorTitle = 'Forbidden';
                this.errorMessage = 'คุณไม่มีสิทธิ์เข้าถึงหน้านี้ กรุณาติดต่อผู้ดูแลระบบเพื่อตรวจสอบสิทธิ์ของบัญชี';
                break;
            case 404:
                this.errorTitle = 'Page Not Found';
                this.errorMessage = 'ไม่พบหน้าที่คุณค้นหา';
                break;
            case 500:
                this.errorTitle = 'Server Error';
                this.errorMessage = 'เกิดข้อผิดพลาดที่เซิร์ฟเวอร์';
                break;
            default:
                this.errorTitle = 'Error';
                this.errorMessage = 'เกิดข้อผิดพลาด';
        }
    }
}
